module.exports = __webpack_public_path__ + "img/5cb737c.png";